/**
 * Expandable group (used for PAGE Impact/outcomes)
 */

import React from "react";
import { Link } from "gatsby";
import parse from "html-react-parser";
import { kebabCase } from "lodash";
import Expandable from "./expandable";
import CopyLinkButton from "./copy-link-button";
import { GatsbyImage, getImage } from "gatsby-plugin-image";


function useHasMounted() {
  const [hasMounted, setHasMounted] = React.useState(false);
  React.useEffect(() => {
    setHasMounted(true);
  }, []);
  return hasMounted;
}

const ExpandableGroup = ({ group, index, props, annualReport, backgroundColor: backgroundColorSection, columnCount }) => {
  const hasMounted = useHasMounted();
  if (!hasMounted) {
    return null;
  }
  const { backgroundColor, heading, icon } = group;
  const image = {
    src: icon?.localFile
      ? getImage(icon?.localFile)
      : null,
    extension: icon?.localFile?.extension,
    alt: icon?.altText || ``,
    publicURL: icon?.localFile?.publicURL,
  }
  const title = props?.title || heading
  const leadContent = group?.leadContent
  const expandableBlock = group?.expandableBlock
  const introBlock = title || image?.src || image?.publicURL || leadContent ? true : false
  return (
    <li
      className={` print:border print:border-gray-300 print:my-4 ${columnCount > 1 || !expandableBlock ? "" : "lg:p-12"} ${annualReport === "2024" ? "" : annualReport === "2023" ? `bg-cover ${title || leadContent || expandableBlock ? "p-8" : ""}` : "rounded-lg p-8"} print:bg-transparent 
      ${annualReport ?
          annualReport === "2024" ? "" :
            (backgroundColorSection === "mixed" ?
              annualReport === "2023" ?
                `bg-white/50 bg-blend-lighten ${index % 3 === 0 ? "bg-blue-blobs" : index % 3 === 1 ? "bg-teal-blobs" : "bg-green-blobs"}` :
                `${index % 3 === 0 ? "bg-blue-100" : index % 3 === 1 ? "bg-teal-50" : "bg-green-100"}`
              : annualReport === "2023" ? (backgroundColorSection === "blue" || backgroundColorSection === "green" || backgroundColorSection === "teal" || backgroundColorSection === "gray" ? "bg-white/70" : "bg-blue-100/70")
                : (backgroundColorSection === "blue" || backgroundColorSection === "green" || backgroundColorSection === "teal" || backgroundColorSection === "gray" ? "bg-white" : "bg-blue-100"))
          : backgroundColor && backgroundColor !== "transparent"
            ? `bg-${backgroundColor}`
            : "transparent"
        } ${annualReport === "2022" ? `border-l-6 border-b-6 relative ${backgroundColorSection === "white" || backgroundColorSection === "blue" || (backgroundColorSection === "mixed" && index % 3 === 0) ? "border-blue" :
          backgroundColorSection === "green" || backgroundColorSection === "gray" || (backgroundColorSection === "mixed" && index % 3 === 2) ? "border-green" :
            backgroundColorSection === "teal" || (backgroundColorSection === "mixed" && index % 3 === 1) ? "border-teal" : "border-blue"}` : ""
        } `}
      key={title}
    >
      <div
        className={`grid ${columnCount > 1 ? "grid-cols-1" : "xl:grid-cols-4 gap-6 xl:gap-10"}
`}
        key={title}
      >
        {introBlock ? <div className={`print:border-b print:border-gray-300 print:pb-8 ${expandableBlock ? "xl:col-span-1" : "col-span-full"} `}>
          {title && props?.uri ? (
            <div className="group-copy-link group">
              <h3
                className="mb-4 text-xl xl:text-2xl anchor-heading"
                id={kebabCase(title)}
              >
                <Link className="text-body" to={props.uri}>
                  {parse(title)}
                </Link>
              </h3>
              <CopyLinkButton heading={title} />
            </div>
          ) : heading ? (
            <h3
              className="mb-4 text-xl xl:text-2xl"
            >
              {parse(heading)}
            </h3>
          ) : null}

          {image?.src ?

            <GatsbyImage
              image={image.src}
              className={`aspect-video ${annualReport === "2024" ? "rounded-lg mb-4" : annualReport === "2023" ? `${expandableBlock ? "mb-2 max-w-sm xl:max-w-none" : "w-full max-w-none"}` :
                annualReport === "2022" ? (`rounded-lg border-l-6 border-b-6"  ${backgroundColorSection === "white" || backgroundColorSection === "blue" || (backgroundColorSection === "mixed" && index % 3 === 0) ? "border-blue" :
                  backgroundColorSection === "green" || backgroundColorSection === "gray" || (backgroundColorSection === "mixed" && index % 3 === 2) ? "border-green" :
                    backgroundColorSection === "teal" || (backgroundColorSection === "mixed" && index % 3 === 1) ? "border-teal" : "border-blue"}`)
                  : "max-w-xs xl:max-w-none"
                } `}
              alt={image.alt}
            />

            : image?.publicURL ? (
              <img
                src={image.publicURL}
                className={`aspect-video max-w-xs xl:max-w-none`}
                alt={image.alt}
              />
            ) : null}

          {leadContent ? (
            <div
              className="parsed-content mb-4"
            >
              {parse(leadContent)}
            </div>
          ) : null}

        </div> : null}
        {expandableBlock ? <div className={`${introBlock ? "xl:col-span-3" : "col-span-full"} print:bg-transparent rounded-md`}>
          <dl className={`gap-y-4 grid ${annualReport === "2024" ? "" : "divide-y divide-gray-300"}`}>
            {expandableBlock?.map((block) => {
              return (
                <div
                  className={`${annualReport === "2024" ? "" : "pt-4 first:pt-0"}`}
                  key={block.heading}
                >
                  <Expandable props={block} annualReport={annualReport} headingLevel="h4"></Expandable>
                </div>
              );
            })}
          </dl>
        </div> : null}
      </div>
    </li>
  );
};

export default ExpandableGroup;
